/* Platinum */
import Catana from '../../images/sponsors/1 - platinum/catana.png';
import GrupoPR from '../../images/sponsors/1 - platinum/grupo-pr.png';
import Mystic from '../../images/sponsors/1 - platinum/mystic.png';
import Palbit from '../../images/sponsors/1 - platinum/palbit.svg';

/* Gold */
import Coficab from '../../images/sponsors/2 - gold/coficab.png';
import Einhell from '../../images/sponsors/2 - gold/einhell.png';
import Elio from '../../images/sponsors/2 - gold/elio.png';
import Lotactree from '../../images/sponsors/2 - gold/lotactree.avif';
import Maximoferta from '../../images/sponsors/2 - gold/maximoferta.png';
import Movella from '../../images/sponsors/2 - gold/movella.png';
import Quantal from '../../images/sponsors/2 - gold/quantal.avif';

import BgCatana from '../../images/sponsors/bg/catana.jpg';
import BgGrupoPR from '../../images/sponsors/bg/grupopr.jpg';
import BgMystic from '../../images/sponsors/bg/mystic.png';
import BgPalbit from '../../images/sponsors/bg/palbit.jpeg';

import { Link } from 'react-router-dom';

function Sponsors() {
    
    const platinum_sponsors = [
        {name: "Catana Group Portugal", link: 'https://www.catanagroup.com/en/', logo: Catana, description: "Catana Group Portugal, based in Vagos, is a company specializing in the leisure marine industry, specifically in the production of catamarans.", bg: BgCatana},
        {name: "Grupo PR", link: 'https://www.prgrupo.com/pt/', logo: GrupoPR, description: "Grupo PR, based in Porto, specializes in industrial solutions for the automotive sector, including custom processes and precision components.", bg: BgGrupoPR},
        {name: "Mystic Invest Holding", link: 'https://www.mysticinvest.com/', logo: Mystic, description: "Mystic Invest is a family-owned financial holding with multiple brands operating in the travel & tourism sector.", bg: BgMystic},
        {name: "Palbit", link: 'https://www.palbit.pt/pt', logo: Palbit, description: "Palbit, based in Palhal, is a cutting tool manufacturer specializing in high-performance solutions for industries like aerospace and automotive.", bg: BgPalbit},
    ];

    const gold_sponsors = [
        {name: "Coficab", link: 'https://www.coficab.com/', logo: Coficab},
        {name: "Einhell", link: 'https://www.einhell.pt/', logo: Einhell},
        {name: "Elio Kayaks", link: 'http://www.eliokayaks.com/', logo: Elio},
        {name: "Lotactree", link: 'https://www.lotactree.com/', logo: Lotactree},
        {name: "Maximoferta", link: 'https://www.maximoferta.com/pt/', logo: Maximoferta},
        {name: "Movella", link: 'https://www.xsens.com/movella', logo: Movella},
        {name: "Quantal", link: 'https://www.quantal.pt/', logo: Quantal}
    ];

    return (
        <div className="min-h-screen w-full py-16 bg-white">
            <h1 className="text-4xl md:text-6xl text-gray-900 font-bold text-center mb-4">Our Sponsors</h1>
            <p className="text-gray-500 text-center mb-16">Thank you to our partners who support our mission</p>
            
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-700 mb-10">Platinum Sponsors</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto px-4">
                {platinum_sponsors.map((sponsor) => (
                    <a 
                        key={sponsor.name}
                        href={sponsor.link}
                        target="_blank"
                        rel="noreferrer"
                        className="group relative h-72 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
                    >
                        <img 
                            src={sponsor.bg} 
                            alt={sponsor.name} 
                            className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-black/50 group-hover:bg-black/70 transition-colors duration-300" />
                        <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
                            <div className="w-28 h-28 bg-white/95 rounded-2xl p-4 shadow-lg transform group-hover:scale-110 transition-transform duration-300 flex items-center justify-center">
                                <img src={sponsor.logo} alt={sponsor.name} className="w-full h-full object-contain" />
                            </div>
                            <h3 className="text-xl font-bold text-white mt-3 drop-shadow-md">{sponsor.name}</h3>
                            <p className="text-gray-200 text-sm mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 max-w-[220px]">{sponsor.description}</p>
                        </div>
                    </a>
                ))}
            </div>

            <h2 className="text-xl md:text-2xl font-bold text-center text-gray-500 mb-10 mt-16">Gold Sponsors</h2>
            <div className="flex flex-wrap justify-center gap-6 px-4">
                {gold_sponsors.map((sponsor) => (
                    <a 
                        key={sponsor.name}
                        href={sponsor.link} 
                        target="_blank" 
                        rel="noreferrer"
                        className="bg-gray-50 hover:bg-gray-100 rounded-xl p-5 border border-gray-200 hover:border-gray-300 transition-all hover:scale-105"
                    >
                        <img src={sponsor.logo} alt={sponsor.name} className="w-32 h-20 object-contain" />
                    </a>
                ))}
            </div>

            <div className="text-center mt-16">
                <Link to={"/sponsors"} className="inline-block px-8 py-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-xl hover:from-blue-600 hover:to-blue-700 transition-all shadow-lg hover:shadow-xl">
                    View All Sponsors
                </Link>
            </div>
        </div>
    );
}

export default Sponsors;